module.exports = __webpack_public_path__ + "static/media/Twenty.48731ae5.ogg";